module.exports = __webpack_public_path__ + "img/console.d39434fd.svg";